import { axios } from '#api/axios';
import { useNavigate } from 'react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from '#providers/ToastProvider';
import { AxiosResponse } from 'axios';

type TrainerCommunityWriteProps = {
  category: string;
  title: string;
  content: string;
};

const useThreadMutations = ({ id }: { id?: string }) => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: threadMutate } = useMutation({
    mutationFn: async (payload: TrainerCommunityWriteProps) => {
      return id
        ? await axios.patch(`/trainers/questions/${id}`, payload)
        : await axios.post('/trainers/questions', payload);
    },
    onSuccess: (response: AxiosResponse) => {
      queryClient.invalidateQueries({ queryKey: ['get-trainer-community'] });
      queryClient.invalidateQueries({
        queryKey: ['get-trainer-community-thread', id]
      });
      showToast({
        message: `글을 ${id ? '수정' : '작성'}하였습니다.`
      });

      return navigate(`/trainer-community/${response.data}`);
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: `글 ${id ? '수정' : '작성'}에 실패했습니다.`
      });

      return navigate('/trainer-community');
    }
  });

  return { threadMutate } as const;
};

export default useThreadMutations;
